import { render, staticRenderFns } from "./selectable-block.vue?vue&type=template&id=285536d0&scoped=true"
import script from "./selectable-block.vue?vue&type=script&lang=js"
export * from "./selectable-block.vue?vue&type=script&lang=js"
import style0 from "./selectable-block.vue?vue&type=style&index=0&id=285536d0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "285536d0",
  null
  
)

export default component.exports